// extracted by mini-css-extract-plugin
export const annotation = "Annotation__annotation__4Ug-K";
export const atlasGrotesk = "'AtlasGrotesk'";
export const blue = "Annotation__blue__FOlav";
export const bold = "700";
export const closeButton = "Annotation__closeButton__Wlyk2";
export const content = "Annotation__content__946oF";
export const expanded = "Annotation__expanded__yPRjf";
export const fixed = "Annotation__fixed__xSgIX";
export const golden = "Annotation__golden__uRVGa";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const header = "Annotation__header__0L57q";
export const medium = "500";
export const moduleClass = "Annotation__moduleClass__K9inx";
export const moduleInsight = "Annotation__moduleInsight__Ke3kX";
export const postMode = "Annotation__postMode__yF9KP";
export const regular = "400";
export const responsive = "Annotation__responsive__S5ciL";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const text = "Annotation__text__xIxxs Text__bodyText__20Sxx font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const title = "Annotation__title__uZwaw";